import { useEffect, useState, useContext } from "react";
import { getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { AirlineListItem } from "../AirlineListItem";
import { AirlineContext } from "../context/AirlineContext";
import { AirlineListingFilters } from "./useAirlineListingFilters";

export const useAirlineListing = (filters: AirlineListingFilters) => {
    const [items, setItems] = useState<AirlineListItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { airlineItems, isLoading } = useContext(AirlineContext);

    useEffect(() => {
        if (airlineItems.length) {
            saveData();
        }
    }, [filters, airlineItems]);

    const saveData = (): void => {
        const sortedAndFilteredItems = getSortedAndFilteredItems(airlineItems, filters);
        const itemsToDisplay = getBatch(sortedAndFilteredItems, filters.pageSize, filters.page);

        setTotalItems(sortedAndFilteredItems.length);
        setItems(itemsToDisplay);
    };

    return {
        items,
        totalItems,
        isLoading
    };
};

const getSortedAndFilteredItems = (items: AirlineListItem[], filters: AirlineListingFilters) => {
    const sortedItems = getSortedCollection(items, filters.sortBy, filters.sortOrder);

    return filterItems(sortedItems, filters.name ?? "", filters.code ?? "");
};

const filterItems = (items: AirlineListItem[], name: string, code: string) =>
    items.filter((item) => matchQuery(item.name, name) && matchQuery(item.code, code));
